document.addEventListener('DOMContentLoaded', function() {
  const multicolumnCards = document.querySelectorAll('.multicolumn-card');
  
  multicolumnCards.forEach(card => {
    const link = card.querySelector('.multicolumn-card__info a');
    const imageWrapper = card.querySelector('.multicolumn-card__image-wrapper');
    
    if (link && imageWrapper) {
      imageWrapper.addEventListener('click', function() {
        link.click();
      });
      imageWrapper.style.cursor = 'pointer';
    }
  });
});
